type PageHeroProps = {
  title: string;
  description: string;
  image?: string;
};

export default function PageHero({ title, description, image = "/assets/polishing/hero_marble.webp" }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-foreground-950 pt-28 text-white">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/80 to-foreground-950/30" />
      <div className="section-shell relative py-16 md:py-24">
        <p className="eyebrow text-primary-200">Polishing Singapore</p>
        <h1 className="mt-4 max-w-4xl font-heading text-4xl font-bold leading-tight md:text-6xl">{title}</h1>
        <p className="mt-5 max-w-2xl text-base leading-8 text-background-100 md:text-lg">{description}</p>
      </div>
    </section>
  );
}
